import { timeAgo } from '../../utils/dateUtils'

const STATUS_ICONS = {
  active: { icon: '●', color: 'text-blue-500' },
  resolved: { icon: '✓', color: 'text-emerald-500' },
  flagged: { icon: '⚑', color: 'text-amber-500' },
  needs_attention: { icon: '!', color: 'text-red-500' },
}

export default function ConversationListItem({ conversation, isSelected, onClick, isChecked, onCheck }) {
  const status = STATUS_ICONS[conversation.status] || STATUS_ICONS.active
  const visitor = conversation.visitor_info || {}

  return (
    <div
      onClick={onClick}
      className={`flex items-start space-x-3 px-3 py-3 cursor-pointer transition-colors border-b border-slate-100 ${
        isSelected ? 'bg-brand-50 border-l-2 border-l-brand-500' : 'hover:bg-slate-50'
      }`}
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={(e) => { e.stopPropagation(); onCheck(conversation.id) }}
        className="mt-1 h-3.5 w-3.5 rounded border-slate-300 text-brand-600 focus:ring-brand-500 cursor-pointer"
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-0.5">
          <span className={`text-xs ${status.color}`}>{status.icon}</span>
          <span className="text-[10px] text-slate-400">{timeAgo(conversation.last_message_at)}</span>
        </div>
        <p className="text-xs text-slate-800 truncate font-medium">{conversation.preview || 'No preview'}</p>
        <div className="flex items-center space-x-2 mt-1">
          <span className="text-[10px] text-slate-400">
            {conversation.source === 'whatsapp'
              ? (visitor.phone || 'WhatsApp')
              : `${visitor.browser || 'Unknown'}, ${visitor.device || 'Unknown'}`}
          </span>
          <span className="text-[10px] text-slate-300">·</span>
          <span className="text-[10px] text-slate-400">{conversation.message_count} msgs</span>
          {conversation.source === 'whatsapp' && (
            <span className="text-[10px] px-1.5 py-0.5 bg-green-100 text-green-700 rounded-full font-medium">WA</span>
          )}
        </div>
      </div>
    </div>
  )
}
